import React, { useEffect, useState } from 'react';
import { Table, Alert, Card, Spin } from 'antd';
import axios from 'axios';
import { Container, Row, Col } from 'react-bootstrap';

const TotalCallComponent = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const API_URL = process.env.REACT_APP_API_URL;

  // Lấy username và role từ localStorage
  const localUsername = localStorage.getItem('username');
  const role = localStorage.getItem('role');

  useEffect(() => {
    const fetchLogs = async () => {
      try {
        let url = `${API_URL}/call/logs`;
        // Nếu role không phải admin, chỉ load log của user đó
        if (role !== 'admin') {
          url += `?username=${encodeURIComponent(localUsername)}`;
        }
        const response = await axios.get(url);
        // Giả sử response.data.logs chứa mảng log
        setLogs(response.data.logs || []);
      } catch (err) {
        setError('Error fetching logs: ' + err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchLogs();
  }, [API_URL, localUsername, role]);

  // Định nghĩa các cột hiển thị trong Table (dùng key của dữ liệu backend)
  const columns = [
    { title: 'Tài khoản', dataIndex: 'username', key: 'username' },
    { title: 'Người dùng', dataIndex: 'caller_name', key: 'caller_name' },
    { title: 'Gọi đến', dataIndex: 'to_number', key: 'to_number' },
    { title: 'Thời gian gọi', dataIndex: 'call_start_time', key: 'call_start_time' },
    { title: 'Thời gian cuộc gọi', dataIndex: 'call_duration', key: 'call_duration' },
    { title: 'Recording Details', dataIndex: 'recording_details', key: 'recording_details' },
    { 
      title: 'Trạng thái cuộc gọi', 
      dataIndex: 'call_event', 
      key: 'call_event', 
      render: (text) => <pre style={{ margin: 0 }}>{JSON.stringify(text, null, 2)}</pre>
    },
  ];

  return (
    <Container className="mt-4">
      <Row className="justify-content-center">
        <Col md={10}>
          <Card title="Call Logs" bordered={false}>
            {loading ? (
              <div style={{ textAlign: 'center', padding: '20px' }}>
                <Spin tip="Loading..." />
              </div>
            ) : error ? (
              <Alert type="error" message={error} />
            ) : (
              <Table 
                dataSource={logs} 
                columns={columns} 
                rowKey="id" 
                pagination={{ pageSize: 10 }}
              />
            )}
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default TotalCallComponent;
